import { ReactNode } from 'react';

type Props = {
  children?: ReactNode;
};

export function Dropdown({ children }: Props) {
  return <div className="flex flex-col menu-dropdown max-w-[252px] min-w-full">{children}</div>;
}
